import { render, staticRenderFns } from "./Shirt.vue?vue&type=template&id=60c2a634&scoped=true"
import script from "./Shirt.vue?vue&type=script&lang=js"
export * from "./Shirt.vue?vue&type=script&lang=js"
import style0 from "./Shirt.vue?vue&type=style&index=0&id=60c2a634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2a634",
  null
  
)

export default component.exports